import { getImInfo } from '@/services/im';
import { setLocalStorage, removeToken } from '@/utils/cookies';
import {
  Avatar,
  Dropdown,
  LayoutPage,
  MenuProps,
  Modal,
  Spin,
} from '@sinohealth/butterfly-ui-components';
import { Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useMenuConfig } from '@/common/hooks';
import PageHeader from '@/components/PageHeader';
import { hideInMenuPages } from '@/config/router';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useRecoilState, useRecoilValue } from 'recoil';

import SwitchChainModal from '@/components/SwitchChainModal';
import MessagePage from '@/components/messagePage';
import { userInfoAtom } from '@/store/atom';
import PasswordModal from '../user/password-modal';
import UserInfoModal from '../user/userinfo-modal';
import style from './index.less';

import BaseTim from '@/core/tim';
import { sysUserInfo } from '@/hooks/sysUserInfo';
import { previewFile } from '@/utils';

function Home(props: any) {
  const [collapsed, setCollapsed] = useState(true);
  useEffect(() => {
    getImInfo({})
      .then((res) => {
        BaseTim.SDKAppID = res?.sdkAppId;
        BaseTim.userSig = res?.userSig;
        BaseTim.userId = res?.userId;
        BaseTim.organizeId = res?.chainId;
        BaseTim.tenantId = res?.tenantId;
        if (res) {
          setLocalStorage('imInfo', res);
          BaseTim.getTim();
        }
      })
      .catch(() => {
        /* Request errors are already displayed. */
      });
  }, []);
  const [menuConfig, setMenuConfig] = useState<any>({});
  const navigate = useNavigate();
  const location = useLocation();
  const [isFlag, setIsFlag] = useState(false);
  const [Info] = sysUserInfo(isFlag);
  const [headerMenuList, sideMenuList, defaultSelected] = useMenuConfig();
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const userInfoStore = useRecoilValue(userInfoAtom);
  const [passwordModalVisible, setPasswordModalVisible] = useState<any>(false);
  const [userInfoModalVisible, setUserInfoModalVisible] = useState<any>(false);
  const [switchChainModalVisible, setSwitchChainModalVisible] = useState<any>(false);

  useEffect(() => {
    // getUserInfo({}).then((data) => {
    //   if (data) {
    //     setUserInfo(data);
    //   }
    // });
    setUserInfo(userInfoStore);
  }, [userInfoStore]);

  useEffect(() => {
    // setIsFlag(!isFlag);
  }, []);

  // 拼装菜单数据，配置内容跟Menu组件保持一致，增加了menuList数据渲染
  useEffect(() => {
    const collapsedNow = hideInMenuPages.indexOf(location.pathname) > -1;
    setCollapsed(collapsedNow);
    const sideMenuConfig = {
      key: Date.now(),
      menuList: sideMenuList,
      defaultSelectedKeys: defaultSelected.sideMenuSelectedKeys,
      defaultOpenKeys: defaultSelected.defaultOpenKeys,
      onSelect(item: any) {
        navigate(item.key);
      },
    };
    setMenuConfig({
      sideMenu: collapsedNow ? { menuList: [] } : sideMenuConfig,
      headerMenu: {
        key: Date.now(),
        menuList: headerMenuList,
        defaultSelectedKeys: defaultSelected.headerMenuSelectedKeys,
      },
    });
  }, [headerMenuList, sideMenuList, defaultSelected, location]);
  const onLogout = () => {
    Modal.confirm({
      title: '确认退出当前账号？',
      icon: <ExclamationCircleOutlined />,
      content: '退出将跳转到登录页，需重新登录才可访问系统',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        BaseTim.destroy();
        removeToken();
        navigate('/login');
      },
    });
  };
  const onClosePasswordModal = () => {
    setPasswordModalVisible(false);
  };
  const onCloseUserInfoModal = (values: any) => {
    if (values.pic) {
      setUserInfo({ ...userInfo, avatar: values.pic });
    }
    setUserInfoModalVisible(false);
  };
  const onSelectedChain = () => {
    navigate('/');
    setSwitchChainModalVisible(false);
  };
  const logo = <div>全病程管理服务平台</div>;
  const menu = [
    {
      label: '资料设置',
      key: '/personal/dataSettings',
      icon: <span className="iconfont icon-cluster" style={{ marginRight: 5 }} />,
    },
    {
      label: '修改密码',
      key: '/personal/changePassword',
      icon: <span className="iconfont icon-setting1" style={{ marginRight: 5 }} />,
    },
    {
      label: '登录记录',
      key: '/personal/loginRecord',
      icon: <span className="iconfont icon-change-chain" style={{ marginRight: 5 }} />,
    },
    {
      label: '退出登录',
      key: 'onLogout',
      icon: <span className="iconfont icon-out" style={{ marginRight: 5 }} />,
    },
  ];
  const handleMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === 'onLogout') {
      onLogout();
      return;
    }
    navigate(e.key);
  };
  const toolbar = (
    <div className={style.headerToolbar}>
      <MessagePage />
      <Dropdown menu={{ items: menu, onClick: handleMenuClick }} placement="bottomRight">
        <div className={style.userInfo}>
          <Avatar src={userInfo?.avatar && previewFile(userInfo?.avatar)} />
          {userInfo && userInfo?.name}
        </div>
      </Dropdown>
    </div>
  );
  const loading = (
    <div style={{ display: 'flex', height: 'calc(100vh - 360px)' }}>
      <Spin size="large" style={{ margin: 'auto' }} />
    </div>
  );
  return (
    <div className={style.home}>
      <LayoutPage menuConfig={menuConfig} collapsed={collapsed} logo={logo} toolbar={toolbar}>
        <Suspense fallback={loading}>
          <div className={style.homeBody} style={{ padding: collapsed ? '0' : '8px' }}>
            <PageHeader />
            <div className={style.homeBodyContent}>
              <Outlet />
            </div>
          </div>
        </Suspense>
      </LayoutPage>
      {passwordModalVisible && (
        <PasswordModal open={true} onCancel={onClosePasswordModal} onOk={onClosePasswordModal} />
      )}
      {userInfoModalVisible && (
        <UserInfoModal open={true} onCancel={onCloseUserInfoModal} onOk={onCloseUserInfoModal} />
      )}
      {switchChainModalVisible && (
        <SwitchChainModal
          open={true}
          // chainId={data?.chainId || '1'}
          chainId="1"
          onOk={onSelectedChain}
          onCancel={() => setSwitchChainModalVisible(false)}
          cancelBtnText="返回"
        />
      )}
      {/* 消息抽屉 */}
      {/* <MsgDrawer
        open={visible}
        refreshUnrea={() => {
          setUnrea(Math.random()); // 刷新红点数
        }}
        ifOpMsgCount={() => {
          setVisible(!visible);
        }}
      /> */}
    </div>
  );
}

export default Home;
